// CandidateChallanDetails_new.jsx. Only text OUTSIDE #divChallanPrint is covered here — that div is
// the html2canvas/jspdf print/PDF-export payload and is explicitly left untouched by this migration
// (see the file's own Stage 3.5 comment on the <Card> import). printChallanHeading and
// challanNotSetError were already bilingual in the file, using an old "English (Marathi)" parenthetical
// format — extracted as-is, now rendered via Text's standardized single-line "English / मराठी" format
// (Stage 3.9 Task 2). cancelButton/previousButton/continueButton/downloadChallanButton were already
// bilingual (2-stacked-div displayInGrid format) — extractions, zero new translation authored. noteLabel
// and preparingChallan had no existing Marathi anywhere in the file — AI-authored, needs linguistic QA.
export default {
  printChallanHeading: { en: 'Print Challan', mr: 'चलन प्रिंट करा' },
  challanNotSetError: {
    en: 'Challan Details are not set for this exam, please contact Admin.',
    mr: 'या परीक्षेसाठी चलन तपशील सेट केलेले नाहीत, कृपया ऍडमिनशी संपर्क साधा.'
  },
  // AI-authored, needs linguistic QA
  noteLabel: { en: 'Note:', mr: 'नोंद:' },
  cancelButton: { en: 'Cancel', mr: 'रद्द करा' },
  previousButton: { en: 'Previous', mr: 'मागे' },
  continueButton: { en: 'Continue', mr: 'पुढे जा' },
  downloadChallanButton: { en: 'Download Challan', mr: 'चलन डाउनलोड करा' },
  // AI-authored, needs linguistic QA
  preparingChallan: { en: 'Preparing…', mr: 'तयार करत आहे…' }
};
